import React from 'react'
import '../../css/AlertModal.scss'
const AlertModal = (props) => {
    const { msg = '', onClose = () => { } } = props
    return (
        <div className="alertModal-overlay" id="modalOverlay">
            <div className='container'>
                <div style={{ textAlign: 'center' }}>
                    <svg
                        width={34}
                        height={34}
                        viewBox="0 0 34 34"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M15.333 25.3333H18.6663V15.3333H15.333V25.3333ZM16.9997 12C17.4719 12 17.8677 11.8403 18.1872 11.5208C18.5066 11.2014 18.6663 10.8055 18.6663 10.3333C18.6663 9.86109 18.5066 9.46526 18.1872 9.14581C17.8677 8.82637 17.4719 8.66665 16.9997 8.66665C16.5275 8.66665 16.1316 8.82637 15.8122 9.14581C15.4927 9.46526 15.333 9.86109 15.333 10.3333C15.333 10.8055 15.4927 11.2014 15.8122 11.5208C16.1316 11.8403 16.5275 12 16.9997 12ZM16.9997 33.6666C14.6941 33.6666 12.5275 33.2291 10.4997 32.3541C8.4719 31.4791 6.70801 30.2916 5.20801 28.7916C3.70801 27.2916 2.52051 25.5278 1.64551 23.5C0.770508 21.4722 0.333008 19.3055 0.333008 17C0.333008 14.6944 0.770508 12.5278 1.64551 10.5C2.52051 8.4722 3.70801 6.70831 5.20801 5.20831C6.70801 3.70831 8.4719 2.52081 10.4997 1.64581C12.5275 0.770813 14.6941 0.333313 16.9997 0.333313C19.3052 0.333313 21.4719 0.770813 23.4997 1.64581C25.5275 2.52081 27.2913 3.70831 28.7913 5.20831C30.2913 6.70831 31.4788 8.4722 32.3538 10.5C33.2288 12.5278 33.6663 14.6944 33.6663 17C33.6663 19.3055 33.2288 21.4722 32.3538 23.5C31.4788 25.5278 30.2913 27.2916 28.7913 28.7916C27.2913 30.2916 25.5275 31.4791 23.4997 32.3541C21.4719 33.2291 19.3052 33.6666 16.9997 33.6666Z"
                            fill={'#0086FF'}
                        />
                    </svg>
                </div>
                <div className='text-section'>
                    {msg}
                </div>
                <button autoFocus={true} onClick={onClose}
                    onKeyDown={(e) => {
                        if (e.keyCode === 32 || e.key === "Enter") {
                            onClose()
                        }
                    }}
                >
                    Ok
                </button>
            </div>
        </div>
    )
}

export default AlertModal